import API from '@/js/data/API'
import DataScrapbooks from "@/js/data/controllers/DataScrapbooks.js";

const DataUser = {
  async login (apiParams) {
      try {
        let params = {slug: '/api/login', apiParams: apiParams}
        let data = await API.getData(params)
        DataUser.loadData()
        return data
      } catch(err) {
        return false
      }
  },

  loadData () {
    DataScrapbooks.getList()
    DataScrapbooks.getScrapbookData()
  }

}

export default DataUser
